import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#d1b3ff',
      dark: 'rgb(125, 77, 255)',
    },
    secondary: {
      main: 'rgb(105, 60, 220)', // Darker green
    },
    background: {
      default: '#1a1a1a', // Dark background
      paper: '#2e2e2e', // Slightly lighter background
    },
    text: {
      primary: '#ffffff', // White text
      secondary: 'rgb(165, 117, 255)', // Light green for secondary text
    },
  },
  typography: {
    fontFamily: "Arial, sans-serif",
    body1: {
      fontSize: '1rem',
      lineHeight: 1.6,
    },
    h6: {
      fontWeight: 'bold',
      color: '#ffffff',
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: '#1a1a1a',
          color: '#ffffff',
          fontFamily: "Arial, sans-serif",
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: '#2e2e2e',
          color: '#ffffff',
          borderRadius: '8px',
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#555 !important', // <--- force with !important
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#d1b3ff !important', // <--- force with !important
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#d1b3ff !important', // <--- force with !important
          },
          input: {
            color: '#ffffff',
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
          backgroundColor: '#2e2e2e',
          '& .MuiOutlinedInput-root': {
            borderRadius: '8px',
            backgroundColor: '#2e2e2e',
          },
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#555 !important', // <--- force with !important
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#d1b3ff !important', // <--- force with !important
          },
          '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#d1b3ff !important', // <--- force with !important
          },
        },
      },
    },
    // --- Date/Time Picker slots ---
    // MuiPickersTextField: {
    //   defaultProps: {
    //     variant: 'outlined',
    //   },
    //   styleOverrides: {
    //     root: {
    //       borderRadius: '8px',
    //       backgroundColor: '#2e2e2e',
    //       '& .MuiOutlinedInput-root': {
    //         borderRadius: '8px',
    //         backgroundColor: '#2e2e2e',
    //       },
    //       '& .MuiOutlinedInput-notchedOutline': {
    //         borderColor: '#555 !important', // <--- force with !important
    //       },
    //       '&:hover .MuiOutlinedInput-notchedOutline': {
    //         borderColor: 'rgb(125, 77, 255) !important', // <--- force with !important
    //       },
    //       '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
    //         borderColor: 'rgb(125, 77, 255) !important', // <--- force with !important
    //       },
    //     },
    //   },
    // },
    // MuiPickersDay: {
    //   styleOverrides: {
    //     root: {
    //       color: '#ffffff',
    //       '&.Mui-selected': {
    //         backgroundColor: 'rgb(125, 77, 255)',
    //       },
    //       '&:hover': {
    //         backgroundColor: 'rgb(105, 60, 220)',
    //       },
    //     },
    //     today: {
    //       borderColor: 'rgb(125, 77, 255)',
    //     },
    //   },
    // },
    // MuiPickersPopper: {
    //   styleOverrides: {
    //     paper: {
    //       backgroundColor: '#2e2e2e',
    //       color: '#ffffff',
    //       borderRadius: '8px',
    //     },
    //   },
    // },
    MuiInputAdornment: {
      styleOverrides: {
        root: {
          '& .MuiSvgIcon-root': {
            color: '#d1b3ff', // Forest green for icons inside InputAdornment
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: 'rgb(165, 117, 255)', // Light green for labels
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          backgroundColor: '#d1b3ff', // Forest green buttons
          color: '#1a1a1a',
          fontWeight: 'bold',
          '&:hover': {
            backgroundColor: 'rgb(105, 60, 220)', // Darker green on hover
            color: '#ffffff',
          },
          '&.Mui-disabled': {
            backgroundColor: '#555', // Disabled button color
            color: '#aaa',
          },
        },
      },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          marginTop: '1rem',
          color: '#ffffff',
          '.MuiFormControlLabel-label': {
            color: 'rgb(165, 117, 255)', // Light green for checkbox labels
          },
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: '#d1b3ff', // Forest green for checkboxes
          '&.Mui-checked': {
            color: '#d1b3ff',
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
          backgroundColor: '#2e2e2e',
          color: '#ffffff',
        },
        icon: {
          color: '#d1b3ff', // Forest green for dropdown arrow
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          // backgroundColor: 'rgb(125, 77, 255)', // Forest green for the header
          backgroundColor: 'rgb(125, 77, 255, 0.4)', // Forest green with transparency' , // forest green with transparency
          color: '#ffffff',
          boxShadow: 'none',
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: 'rgb(105, 60, 220)', // Darker green for the drawer
          color: '#ffffff',
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          color: 'rgb(145, 97, 255)', // Brighter green for links
          textDecoration: 'none',
          fontWeight: 'bold',
          transition: 'color 0.3s ease',
          '&:hover': {
            color: '#ffffff', // White on hover
          },
          '&:focus': {
            outline: '2px solid rgb(145, 97, 255)', // Focus outline for accessibility
            outlineOffset: '2px',
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          backgroundColor: 'rgb(105, 60, 220)',
          color: 'rgb(165, 117, 255)',
          fontWeight: 'bold',
          fontSize: '1.1rem',
          borderBottom: '2px solid #d1b3ff',
        },
        body: {
          color: '#ffffff',
          fontSize: '1rem',
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          '&:nth-of-type(odd)': {
            backgroundColor: '#232323',
          },
          '&:nth-of-type(even)': {
            backgroundColor: '#2e2e2e',
          },
          '&:hover': {
            backgroundColor: 'rgb(90, 50, 190)',
          },
        },
      },
    },
  },
});

export default theme;